import type { FaireProductEntity } from "../../entity_types/product";

export const p_an38x4bbyx: FaireProductEntity = {
  token: "p_an38x4bbyx",
  type: "product",
  name: "Tiger Eye Crystal Sphere, Tiger Eye Ball",
  brandToken: "b_qyxxvd286n",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d1d2c74f5ee062b9b020c97578f611a09a7908f2b9347b82d77f47c64730217a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c05a725510149496c2a73db32a10ddb1013a1fd0e7a0d7238e6dc1016ba5dec.jpeg",
    "https://cdn.faire.com/fastly/0489dfdd1004938d5c214ddb521127b284f72f2f873979f9f116428b9803c185.jpeg",
    "https://cdn.faire.com/fastly/11b3c3e8a765fe04c849b405e2334ad3fe6b84469ca72bc840b413300811fe84.jpeg",
    "https://cdn.faire.com/fastly/695ed3bde191b2340af1a9b2300e6f050f74076c99ae2cba176e3c2078534ccf.jpeg",
  ],
  priceDollars: 11.09,
  description:
    'Tiger Eye Crystal Sphere\n=======\nSize:\n- Diameter: 55-57 mm approx.\n- Weight: 230 Grams\n==\nTiger’s Eye Crystal Sphere is a striking and powerful stone known for its golden-brown bands that shimmer in the light, resembling a tiger’s eye. It’s a stone of courage, strength, and personal power, with a grounding energy that connects deeply to the root chakra while also activating the solar plexus chakra—the center of self-confidence and willpower.\nHere’s what makes Tiger’s Eye so special:\n•\tCourage & Protection: Often considered a "warrior stone," it’s believed to boost courage, confidence, and inner strength, helping you face challenges head-on.\n•\tBalance & Grounding: It brings balance between the emotional and physical realms.\n\nNOTE - There will be slight variation in terms of color, texture size, weight etc... as Gemstones have some wonderful variations unique to each stone.\nColors can vary from lot to lot, even inside the lots. This is natural for natural gemstones. ',
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:09.744Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
